<style lang="scss" scoped>
.tools {
  margin-bottom: 10px;
}

.item {
  padding-top: 10px;
  .info {
    background-color: #fff;
    padding: 15px;
    border-color: #d7dde4;
    border-collapse: separate;
    border-style: solid;
    border-width: 1px 1px 0 1px;
    .right {
      float: right;
    }
    .i {
      width: 100px;
      display: inline-block;
    }
  }
}
</style>

<template>
  <div>
    <div class="tools">
      <i-button @click="down">导出</i-button>
    </div>
    <!-- <div class="tools">
    <i-input v-model="query" placeholder="请输入..." style="width: 200px"></i-input>
    <i-button @click="load">查询</i-button>
    </div>-->
    <div class="item" v-for="row in source" :key="row.no">
      <div class="info">
        <span class="i">{{ row.no }}</span>
        <span class="i">{{ row.name }}</span>
        <span class="i">{{ row.phone }}</span>
        <span class="right">{{ row.saleName }} {{ row.createdAt }}</span>
      </div>
      <i-table highlight-row :columns="columns" :data="row.orders"></i-table>
    </div>
  </div>
</template>

<script>
import dayjs from 'dayjs';
import filter from 'lodash/filter';
import download from 'downloadjs';

export default {
  components: {},
  data() {
    return {
      showModal: false,
      createDate: '',
      targetNo: '',
      query: '',
      // page: {
      //   total: 0,
      //   current: 1,
      //   pagesize: 10
      // },
      columns: [
        {
          title: '编码',
          key: 'categoryId',
        },
        {
          title: '名称',
          key: 'name',
        },
        {
          title: '数量',
          key: 'count',
        },
        {
          title: '价格',
          key: 'price',
        },
        {
          title: '合计',
          key: 'total',
        },
      ],
      source: [],
      currentRow: {},
    };
  },
  mounted() {
    this.load();
  },
  methods: {
    load() {
      // let { current, pagesize } = this.page;

      this.$http
        .post('monitor/delivery', {
          name: this.query,
          ready: true,
          // offset: (current - 1) * pagesize,
          // limit: pagesize
        })
        .then(({ data }) => {
          if (data.msg === 'ok') {
            let source = data.rows.map((r) => {
              r.createdAt = dayjs(r.createdAt).format('YYYY-MM-DD');
              r.orders.forEach((o) => {
                o.count = -o.count;
                o.total = o.count * o.price;
              });
              return r;
            });

            if (this.$route.query.sale) {
              source = filter(source, { sale: this.$route.query.sale });
            }

            this.source = source;
            // this.page.total = data.count;
          }
        });
    },
    pageChange() {
      this.load();
    },
    down() {
      this.$http.post('monitor/delivery/export').then(({ data }) => {
        if (data.msg === 'ok') {
          download(
            'data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,' +
              data.base64
          );
        }
      });
    },
  },
};
</script>
